import Cookies from "js-cookie";
import Path from "./Path";
import { flush as flushActivity } from "./ActivityTracker";
import { clearAuthSession } from "./authSession";

async function notifyServerLogout() {
	const token = Cookies.get("_cb_search_token");
	if (!token || token === "undefined" || token === "null") return;
	try {
		await fetch(`${Path("ms1")}api/v1/user/logout`, {
			method: "POST",
			body: "{}",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});
	} catch (_) {
		/* ignore */
	}
}

/** Clears client auth state and notifies the API when a session token is present. */
export async function performClientLogout() {
	if (typeof window !== "undefined" && window.RvBotView) {
		window.RvBotView.destory();
	}
	await notifyServerLogout();
	try {
		await flushActivity();
	} catch (_) {
		/* ignore */
	}
	try {
		localStorage.clear();
	} catch (_) {
		/* ignore */
	}
	clearAuthSession();
	Cookies.remove("_cb_search_token");
	Cookies.remove("_website_id");
}
